import { render, staticRenderFns } from "./WorkflowListSkeleton.vue?vue&type=template&id=73d16e25&scoped=true"
import script from "./WorkflowListSkeleton.vue?vue&type=script&lang=js"
export * from "./WorkflowListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./WorkflowListSkeleton.vue?vue&type=style&index=0&id=73d16e25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d16e25",
  null
  
)

export default component.exports